import * as React from 'react';
import { Loader as Loader$1 } from '@grandvisionhq/common';
import { baseClassName } from '../styles/index.js';

const Loader = ()=>/*#__PURE__*/ React.createElement(Loader$1, {
        className: `${baseClassName}__loader`
    })
;

export { Loader };
//# sourceMappingURL=Loader.js.map
